<template>
  <div class="box white p-3 mb-3" style="min-height: 200px">
    <K2Row space-between="true" class="border-bottom mb-4">
      <K2Text align="left" bold="true" class-name="mb-3" :style="{ fontSize: uiVariable.fontSize.lg }">
        {{ lang('Selected Student') }}
      </K2Text>
      <K2Row>
        <K2Button class="me-2" theme="2" size="small" @onclick="$emit('clearStudents')">{{ lang('Clear All') }} </K2Button>
        <K2Button class="me-2" theme="2" size="small" @onclick="handleSelectStudent()">{{ lang('Select') }} </K2Button>
        <div v-b-toggle="'activityStudent'">
          <K2Icon color="black" name="expand_less" class="when-open" />
          <K2Icon color="black" name="expand_more" class="when-closed" />
        </div>
      </K2Row>
    </K2Row>
    <b-collapse id="activityStudent" class="px-2 px-md-0 customScroll" visible>
      <div class="row">
        <!--Levels -->

        <div class="col-12" v-if="selectedLevels && selectedLevels.length > 0">
          <K2Row justify_content="flex-start" class="mb-2">
            <K2Text bold="true">{{ lang('Selected Levels') }}:</K2Text>
          </K2Row>
          <div class="row mb-3">
            <div class="col-md-3 mediaItem mb-2" v-for="slevel in selectedLevels" :key="slevel.Str_ID">
              <K2Icon name="close" @onclick="handleRemoveTag('', slevel, 'level')" link="true" class="close" />
              <div class="box purple p-2 rounded">&nbsp;&nbsp; {{ slevel.Str_Display || slevel.PostTagLevelName }}</div>
            </div>
          </div>
        </div>
        <!--Class -->

        <div class="col-12" v-if="selectedClasses && selectedClasses.length > 0">
          <K2Row justify_content="flex-start" class="mb-2">
            <K2Text bold="true">{{ lang('Selected Classes') }}:</K2Text>
          </K2Row>
          <div class="row mb-3">
            <div class="col-md-3 mediaItem mb-2" v-for="sclass in selectedClasses" :key="sclass">
              <K2Icon name="close" @onclick="handleRemoveTag('', sclass, 'class')" link="true" class="close" />
              <div class="box purple p-2 rounded">&nbsp;&nbsp; {{ sclass.Str_Display || sclass.PostTagClassName }}</div>
            </div>
          </div>
        </div>
        <!--Students -->
        <div class="col-12" v-if="selectedStudents && selectedStudents.length > 0">
          <div v-for="category in selectedStudents" :key="category.CLS_ClassName">
            <K2Row justify_content="flex-start" class="mb-3">
              <K2Text bold="true">{{ category.CLS_ClassName }}</K2Text>
            </K2Row>
            <div class="row" v-if="category.itemList.length">
              <div class="col-md-3 mediaItem mb-2" v-for="(student, i) in category.itemList" :key="student.Student_ID + i || student.PostTagUserID + i">
                <K2Icon name="close" @onclick="handleRemoveTag(category, student, 'student', category.CLS_ClassName)" link="true" class="close" />

                <K2Row justify_content="center" class="box purple px-2 py-3 rounded flex-column">
                  <div>
                    <div class="box white d-table m-auto rounded-circle overflow-hidden mb-2">
                      <img :src="student.Profile_Img || assets.image.boy" height="40px" width="40px" />
                    </div>
                  </div>
                  {{ student.First_Name || student.StudentName }}
                </K2Row>
              </div>
            </div>
            <div class="row" v-else>
              <div class="col-md-3 mediaItem mb-2">
                <K2Icon name="close" @onclick="handleRemoveTag(category, category.itemList, 'student', category.CLS_ClassName)" link="true" class="close" />

                <K2Row justify_content="center" class="box purple px-2 py-3 rounded flex-column">
                  <div>
                    <div class="box white d-table m-auto rounded-circle overflow-hidden mb-2">
                      <img :src="category.itemList.Profile_Img || assets.image.boy" height="40px" crossorigin width="40px" />
                    </div>
                  </div>
                  {{ category.itemList.First_Name || category.itemList.StudentName }}
                </K2Row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-collapse>
    <K2Modal :fullscreen="true" :dialog="modal === 'students'" @handleClose="handleClose" @onConfirm="handleConfirm" :confirm-text="lang('Select')">
      <k2-select-student
        @tags="setTags"
        @tagAllLevels="gAllLevels"
        @isCheckAll="setCheckAll"
        :isClear="isClear"
        @selectedlevels="gSelectedLevels"
        @handleClear="handleClear"
        :isMoment="postType === 'Moment'"
        :isBroadcast="postType === 'Broadcast'"
        :selectedLevels="passSelectedLevel"
        :passSelectedStudent="passEditedTags"
        :passSelectedClasses="passEditedClasses"
        :passSelectedLevels="passEditedLevels"
        :passSelectedSchool="passEditedSchool"
        :removedStudent="removedStudent"
        @resetRemovedTag="resetRemovedTag"
        @selectedclasses="gSelectedClasses"
        @isAllClasses="setClasses"
      ></k2-select-student>
    </K2Modal>
  </div>
</template>
<script>
import K2Icon from '../../../../uiComponents/k2Icon/k2MAIcon'
import K2Row from '../../../../uiComponents/k2Row/k2Row'
import uiVariable from '../../../../config/uiVariable'
import K2Button from '../../../../uiComponents/k2Button/k2Button'
import K2Modal from '../../../../uiComponents/k2Modal/k2Modal'
import K2SelectStudent from '../../../../uiComponents/k2SelectStudent/k2SelectStudent'
import K2Text from '../../../../uiComponents/k2Text/k2Text'
import assets from '../../../../assets/assets'
import DataSource from '../../../../data/datasource'
import Cookies from 'js-cookie'
import { lang } from '../../../../locale'

export default {
  name: 'activityStudents',
  components: { K2Text, K2SelectStudent, K2Modal, K2Button, K2Row, K2Icon },
  props: [
    'handleBack',
    'passmselectedstudents',
    'passmseelctedclasses',
    'passSelectedLevel',
    'passisalllevel',
    'sAllLevels',
    'postType',
    'handleResetGoals',
    'clearStudents',
  ],
  data() {
    return {
      assets: assets,
      uiVariable: uiVariable,
      selectedStudents: [],
      removedStudent: [],
      selectedAllLevels: [], //store selected all levels
      selectedClasses: [], //store selected classes
      selectedLevels: [], //store selected levels
      isAllClasses: '',
      isAllLevelsSelected: '',
      modal: '',
      ddlClassList: [],
      ddlLevelList: [],
      isClear: false,
      userRole: '',
      passEditedTags: [],
      passEditedClasses: [],
      passEditedLevels: [],
      passEditedSchool: false,
    }
  },
  watch: {
    passSelectedLevel: function (newVal) {
      if (newVal) {
        // this.selectedLevels = newVal;
        newVal.forEach(d => {
          d.isLevel = true
          d.checked = true
        })
        // this.passEditedLevels = this.selectedLevels;
        this.handleEditPostLevel(newVal)
        // this.$emit("selectedLevels", this.selectedLevels);
      }
    },
    passmselectedstudents: function (newVal) {
      if (newVal) {
        this.handleEditPostStudent(newVal)
      }
    },
    passmseelctedclasses: function (newVal) {
      if (newVal) {
        this.selectedClasses = newVal
        this.passEditedClasses = newVal
        this.$emit('selectedclasses', this.selectedClasses)
        this.handleEditPostClass(newVal)
      }
    },
    passisalllevel: function (newVal) {
      if (newVal) {
        this.isAllLevelsSelected = newVal
        this.passEditedSchool = newVal
        this.selectedLevels = this.ddlLevelList[0].ArrObj_Items
        this.$emit('selectedLevels', this.selectedLevels)
      }
    },
    postType: function (newVal, oldVal) {
      if (newVal) {
        // if (newVal === "Broadcast") {
        //   this.isAllLevelsSelected = true;
        //   this.passEditedSchool = true;
        //   this.selectedLevels = this.ddlLevelList[0].ArrObj_Items;
        //   this.selectedAllLevels = this.ddlLevelList;
        //   this.$emit("selectedLevels", this.selectedLevels);
        //   this.$emit("sAllLevels", this.selectedAllLevels);
        // } else if (oldVal === "Broadcast") {
        //   this.isAllLevelsSelected = false;
        //   this.passEditedSchool = false;
        //   this.selectedLevels = null;
        //   this.selectedClasses = null;
        //   this.selectedAllLevels = null;
        //   this.$emit("selectedLevels", this.selectedLevels);
        //   this.$emit("sAllLevels", this.selectedAllLevels);
        // }
      }
    },
  },
  mounted() {
    this.init()
    const self = this
    this.userRole = Cookies.get('userTypeSession')
    this.resetRemovedTag()
  },
  methods: {
    lang,
    async init() {
      await this.sortByLevelClass()
      this.handleEditPostSchool(this.passisalllevel)
      this.handleEditPostStudent(this.passmselectedstudents)
      this.handleEditPostClass(this.passmseelctedclasses)
      // this.handleEditPostLevel(this.passSelectedLevel);
    },
    showLoading() {
      this.$vs.loading()
    },
    handleEditPostSchool(newVal) {
      if (newVal) {
        this.isAllLevelsSelected = newVal
        this.selectedLevels = this.ddlLevelList[0].ArrObj_Items
        this.selectedClasses = this.ddlClassList
        this.$emit('selectedLevels', this.selectedLevels)
        this.$emit('selectedclasses', this.selectedClasses)
      }
    },
    handleEditPostLevel(newVal) {
      let tempNewTags = []
      newVal.forEach(m => {
        let tempID = m.PostTagLevelID || m.Str_ID
        let levelFound = this.ddlLevelList[0].ArrObj_Items.find(b => b.Str_ID === tempID)
        if (levelFound) {
          tempNewTags.push(levelFound)
        }
      })
      this.selectedLevels = tempNewTags
      // this.$emit("selectedLevels", this.selectedLevels);

      this.passEditedLevels = this.selectedLevels
      this.$emit('handleStudentPlannerOnSelect')
    },
    handleEditPostClass(newVal) {
      let tempNewTags = []
      newVal.forEach(m => {
        let classFound = this.ddlClassList.find(b => b.Str_ID === (m.PostTagClassID || m.Str_ID))
        if (classFound) {
          this.ddlLevelList?.[0]?.ArrObj_Items?.forEach(d => {
            let levelFound = d?.ArrObj_Items?.find(a => a.Str_ID === classFound?.Str_ID)
            if (levelFound) {
              classFound.levelID = d?.Str_ID
            }
          })
          tempNewTags.push(classFound)
        }
      })
      this.selectedClasses = tempNewTags
      this.$emit('selectedclasses', this.selectedClasses)
      this.passEditedClasses = this.selectedClasses
      if (newVal?.length > 0) {
        this.$emit('handleStudentPlannerOnSelect')
      }
    },
    handleEditPostStudent(newVal) {
      let tempNewTags = []
      this.ddlClassList.forEach(d => {
        newVal.forEach(m => {
          if (m.StudentClass && d.Str_ID === m.StudentClass) {
            let studentFound = d.ArrObj_Items.find(b => b.Student_ID === m.PostTagUserID)
            if (studentFound) {
              if (m.StudentClass && m.StudentClass !== undefined) {
                studentFound.StudentClass = m.StudentClass
              }
              tempNewTags.push(studentFound)
            }
          }
        })
      })

      let className
      const newArray = []
      tempNewTags.forEach(e => {
        if (e.StudentClass) {
          let tempName = this.ddlClassList.find(d => d.Str_ID === e.StudentClass)
          className = tempName.Str_Display

          const exist = e.StudentClass ? newArray.find(v => v.CLS_ClassName === className) : newArray.find(v => v.CLS_ClassName === e.CLS_ClassName)
          if (exist) {
            exist.itemList.push(e)
          } else {
            const newObj = {
              CLS_ClassName: e.StudentClass ? className : e.CLS_ClassName,
              classID: e.StudentClass,
              isWholeClass: e.isClass,
              itemList: [e],
            }
            newArray.push(newObj)
          }
        }
      })
      this.selectedStudents = newArray
      this.$emit('tags', this.selectedStudents)
      this.passEditedTags = this.selectedStudents
      if (newVal?.length > 0) {
        this.$emit('handleStudentPlannerOnSelect')
      }
    },
    setTags(tags) {
      let className, isStudentClass
      if (tags.length) {
        isStudentClass = tags.find(d => d.StudentClass)
      } else if (tags.StudentClass) {
        isStudentClass = tags
      }
      if (isStudentClass) {
        let tempName = this.ddlClassList.find(d => d.Str_ID === isStudentClass.StudentClass)
        className = tempName.Str_Display
      }
      const newArray = []
      if (tags.length > 0) {
        tags.forEach(e => {
          if (e.StudentClass) {
            let tempName = this.ddlClassList.find(d => d.Str_ID === e.StudentClass)
            className = tempName.Str_Display
          }

          const exist = e.StudentClass ? newArray.find(v => v.CLS_ClassName === className) : newArray.find(v => v.CLS_ClassName === e.CLS_ClassName)
          if (exist) {
            exist.itemList.push(e)
          } else {
            const newObj = {
              CLS_ClassName: e.StudentClass ? className : e.CLS_ClassName,
              isWholeClass: e.isClass,
              itemList: [e],
            }
            newArray.push(newObj)
          }
        })
      } else if (tags) {
        const exist = isStudentClass ? newArray.find(v => v.CLS_ClassName === className) : newArray.find(v => v.CLS_ClassName === tags.CLS_ClassName)
        if (exist) {
          exist.itemList.push(tags)
        } else if (tags?.Student_ID) {
          const newObj = {
            CLS_ClassName: isStudentClass ? className : tags.CLS_ClassName,
            isWholeClass: tags.isClass,
            itemList: [tags],
          }
          newArray.push(newObj)
        }
      }
      this.selectedStudents = newArray
      this.$emit('tags', this.selectedStudents)
    },
    gAllLevels(alllevels) {
      //Method to store Selected levels in array
      this.selectedAllLevels = alllevels
    },
    setCheckAll(sAllLevels) {
      //Method to know whether alllevel is selected or not
      this.isAllLevelsSelected = sAllLevels
    },
    gSelectedClasses(selClasses) {
      // let newClasses = []
      // selClasses.forEach(d => {
      //   const isLevelSelect = this.selectedLevels.find(v => v.Str_ID === d.levelID)
      //   if (!isLevelSelect) {
      //     newClasses.push(d)
      //   }
      // })
      this.selectedClasses = selClasses
    },
    gSelectedLevels(selLevels) {
      this.selectedLevels = selLevels
    },
    setClasses(sclasses) {
      this.isAllClasses = sclasses
    },
    hideLoading() {
      this.$vs.loading.close()
    },
    handleSelectStudent() {
      this.modal = 'students'
    },
    handleRemoveTag(category, tags, removeType, className) {
      this.resetRemovedTag()

      if (tags) {
        tags.type = removeType
        tags.checked = false
        this.removedStudent = tags
        switch (removeType) {
          // removing a level or class also removes the classes and students under it
          case 'level':
            this.selectedLevels = this.selectedLevels.filter(d => d.Str_ID !== tags.Str_ID)
            this.selectedClasses = this.selectedClasses.filter(d => d.levelID !== tags.Str_ID)
            this.selectedStudents = this.removeStudentsWhere(d => d.PK_Course_ID === tags.Str_ID)
            break
          case 'class':
            this.selectedClasses = this.selectedClasses.filter(d => d.Str_ID !== tags.Str_ID)
            this.selectedStudents = this.removeStudentsWhere(d => d.PK_Class_ID === tags.Str_ID)
            break
          case 'student':
            if (this.selectedStudents.length <= 1) {
              this.selectedStudents = []
            } else {
              this.selectedStudents.forEach(d => {
                if (d.CLS_ClassName === className) {
                  d.itemList = d.itemList.filter(x => x.Student_ID !== tags.Student_ID)
                }
              })
              this.selectedStudents = this.selectedStudents.filter(d => d.itemList.length > 0)
            }
            break
        }

        this.passEditedTags = this.selectedStudents
        this.passEditedClasses = this.selectedClasses
        this.passEditedLevels = this.selectedLevels
        this.$forceUpdate()
        this.$emit('handleResetGoals')
        this.$emit('tags', this.selectedStudents)
        this.$emit('selectedclasses', this.selectedClasses)
        this.$emit('selectedLevels', this.selectedLevels)
      }
    },
    removeStudentsWhere(predicate) {
      return this.selectedStudents.map(d => ({ ...d, itemList: [].concat(d.itemList).filter(x => !predicate(x)) })).filter(d => d.itemList.length > 0)
    },
    resetRemovedTag() {
      this.removedStudent = null
    },
    handleConfirm() {
      let selectLevelList = []
      if (this.selectedAllLevels && this.selectedAllLevels.length) {
        this.selectedAllLevels.forEach(d => {
          selectLevelList.push(d.Str_Display)
        })
      }
      this.$emit('tags', this.selectedStudents)
      this.$emit('sAllLevels', selectLevelList)
      this.$emit('isCheckAll', this.isAllLevelsSelected)
      this.$emit('selectedLevels', this.selectedLevels)
      this.$emit('isAllClasses', this.isAllClasses)
      this.$emit('selectedclasses', this.selectedClasses)
      this.$emit('handleStudentPlannerOnSelect')
      this.handleClose()
    },
    handleClose() {
      this.modal = null
    },
    handleClear(value) {
      this.isClear = value
    },
    isNull(obj) {
      return obj === null || obj === undefined || obj === 'undefined' || obj.length === 0 || obj === ''
    },
    async sortByLevelClass() {
      this.showLoading()
      try {
        const result = await DataSource.shared.getAllActiveStudentsBySchoolWithMode('ProfileImagePhysicalPath')
        if (result) {
          if (result.code === '88') {
            window.location.replace('/')
          } else if (result.code === '99') {
            console.log('getAllActiveStudentsBySchoolWithMode Error')
          } else if (result.code === '2') {
            console.log('getAllActiveStudentsBySchoolWithMode no record')
          } else {
            if (this.isNull(result.Table)) {
              return
            }
            this.groupStudentList2(result.Table)
          }
        }
      } catch (e) {
        console.log('sortByLevelClass err', e)
      }
      this.hideLoading()
    },
    groupStudentList(result) {
      let classList = []
      let levelList = []
      let sortedList = this.groupBy(result, 'SMT_Code', 'SMT_Code')
      for (let i = 0; i < sortedList.length; i++) {
        let tempLevel = this.groupBy(sortedList[i].ArrObj_Items, 'CRS_Course_Name', 'CRS_Course_Name', 'PK_Course_ID')
        for (let j = 0; j < tempLevel.length; j++) {
          let tempClass = this.groupBy(tempLevel[j].ArrObj_Items, 'CLS_ClassName', 'CLS_ClassName', 'PK_Class_ID')
          tempLevel[j].ArrObj_Items = tempClass
        }
        sortedList[i].ArrObj_Items = tempLevel
      }
      sortedList.forEach(d => {
        d.ArrObj_Items.forEach(m => {
          levelList.push(m)
          m.ArrObj_Items.forEach(e => {
            classList.push(e)
          })
        })
      })
      this.ddlClassList = classList
      this.ddlLevelList = levelList
    },
    groupStudentList2(result) {
      const array = []
      let classList = []

      result.forEach(d => {
        const academicYearExist = array.find(v => v.Str_ID.trim() === d.SMT_Code.trim())
        if (academicYearExist) {
          const levelExist = academicYearExist.ArrObj_Items.find(v => v.Str_ID === d.PK_Course_ID)
          if (levelExist) {
            const classExist = levelExist.ArrObj_Items.find(v => v.Str_ID === d.PK_Class_ID)
            if (classExist) {
              classExist.ArrObj_Items.push(d)
            } else {
              const newClass = {
                Str_ID: d.PK_Class_ID,
                Str_Display: d.ClassFullName,
                Str_SortBy: d.ClassFullName,
                ArrObj_Items: [d],
              }
              levelExist.ArrObj_Items.push(newClass)
            }
          } else {
            const newLevel = {
              Str_ID: d.PK_Course_ID,
              Str_Display: d.CRS_Course_Name,
              Str_SortBy: d.CRS_Course_Name,
              ArrObj_Items: [],
            }

            const classExist = newLevel.ArrObj_Items.find(v => v.Str_ID === d.PK_Class_ID)
            if (classExist) {
              classExist.ArrObj_Items.push(d)
            } else {
              const newClass = {
                Str_ID: d.PK_Class_ID,
                Str_Display: d.ClassFullName,
                Str_SortBy: d.ClassFullName,
                ArrObj_Items: [d],
              }
              newLevel.ArrObj_Items.push(newClass)
            }
            academicYearExist.ArrObj_Items.push(newLevel)
          }
        } else {
          const newAcademicYear = {
            Str_ID: d.SMT_Code,
            Str_Display: d.SMT_Code,
            Str_SortBy: d.SMT_Code,
            ArrObj_Items: [],
          }
          const levelExist = newAcademicYear.ArrObj_Items.find(v => v.Str_ID === d.PK_Course_ID)
          if (levelExist) {
            const classExist = levelExist.ArrObj_Items.find(v => v.Str_ID === d.PK_Class_ID)
            if (classExist) {
              classExist.ArrObj_Items.push(d)
            } else {
              const newClass = {
                Str_ID: d.PK_Class_ID,
                Str_Display: d.ClassFullName,
                Str_SortBy: d.ClassFullName,
                ArrObj_Items: [d],
              }
              levelExist.ArrObj_Items.push(newClass)
            }
          } else {
            const newLevel = {
              Str_ID: d.PK_Course_ID,
              Str_Display: d.CRS_Course_Name,
              Str_SortBy: d.CRS_Course_Name,
              ArrObj_Items: [],
            }
            const classExist = newLevel.ArrObj_Items.find(v => v.Str_ID === d.PK_Class_ID)
            if (classExist) {
              classExist.ArrObj_Items.push(d)
            } else {
              const newClass = {
                Str_ID: d.PK_Class_ID,
                Str_Display: d.ClassFullName,
                Str_SortBy: d.ClassFullName,
                ArrObj_Items: [d],
              }
              newLevel.ArrObj_Items.push(newClass)
            }
            newAcademicYear.ArrObj_Items.push(newLevel)
          }
          array.push(newAcademicYear)
        }
      })
      array.forEach(d => {
        d.ArrObj_Items.forEach(m => {
          m.ArrObj_Items.forEach(e => {
            classList.push(e)
          })
        })
      })
      this.ddlClassList = classList
      this.ddlLevelList = array
    },
    groupBy(data, key, display, id) {
      let ArrObj_Sorted = []
      let arrstr_display = !this.isNull(display) ? display.split(',') : [key]
      for (let item of data) {
        let index = ArrObj_Sorted.findIndex(x => x.Str_SortBy === item[key])
        if (index === -1) {
          let str_Display = ''
          for (let tempdisp of arrstr_display) str_Display += item[tempdisp] + ' '
          ArrObj_Sorted.push({
            Str_SortBy: item[key],
            Str_Display: str_Display,
            Str_ID: item[id],
            ArrObj_Items: [item],
          })
        } else ArrObj_Sorted[index].ArrObj_Items.push(item)
      }
      return ArrObj_Sorted
    },
  },
}
</script>
